<template>
  <BaseCenteredModal
    v-model:is-modal-open="localIsModalOpen"
    :title="$t('button.change_item_order')"
    size="medium"
  >
    <template #body>
      <draggable
        v-model="items"
        tag="ul"
        item-key="id"
        :animation="200"
        ghost-class="opacity-50"
        class="flex w-full flex-col gap-2 p-1"
      >
        <template #item="{ element }">
          <li
            class="flex cursor-move items-center gap-4 rounded-md border bg-white px-4 py-2 shadow-xs select-none dark:border-slate-600 dark:bg-slate-700"
          >
            <FontAwesomeIcon
              :icon="['fal', 'sort-alt']"
              class="shrink-0 text-gray-400"
            />
            <span class="min-w-0 flex-1 truncate">{{ element.name }}</span>
            <span class="shrink-0 text-sm text-gray-500">
              {{ element.quantity }} ×
              {{ $h.formatCurrency(element.price_excluding_vat) }}
            </span>
          </li>
        </template>
      </draggable>
    </template>
    <template #footer>
      <BaseButton
        :title="$t('button.send')"
        icon="paper-plane"
        color="primary"
        @click="submitForm"
      />
      <BaseButton :title="$t('button.close')" color="dark" @click="close" />
    </template>
  </BaseCenteredModal>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'

import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'

/**
 * Reorders an invoice's lines: a copy of the list is dragged, the store's
 * invoice only changes once the API has saved the new order.
 */
export default {
  name: 'ChangeItemOrderDialog',
  components: { BaseCenteredModal, draggable, FontAwesomeIcon },
  props: {
    isModalVisible: { type: Boolean, required: true }
  },
  emits: ['close', 'backdropClicked'],
  data() {
    return { items: [] }
  },
  computed: {
    ...mapGetters({ invoice: 'invoicing/getInvoice' }),
    localIsModalOpen: {
      get() {
        return this.isModalVisible
      },
      set(value) {
        if (!value) this.close()
      }
    }
  },
  watch: {
    isModalVisible: {
      immediate: true,
      handler(visible) {
        if (visible) this.items = [...(this.invoice?.invoice_items ?? [])]
      }
    }
  },
  methods: {
    ...mapActions({ reorderInvoiceItems: 'invoicing/reorderInvoiceItems' }),
    close() {
      this.$emit('close')
    },
    submitForm() {
      this.reorderInvoiceItems({
        invoice_id: this.invoice.id,
        ordered_list: this.items.map(({ id }) => ({ id }))
      }).then(() => {
        this.$h.toastSuccess(this.$t('toasts.invoice_updated'))
        this.close()
      })
    }
  }
}
</script>
